export enum DRAFT_ASSIGNMENT {
  editing = 'editing',
  addWell = 'addWell',
  import = 'import',
}
